import React, { useEffect, useState } from 'react'
import { useAuth } from '../../../contexts/AuthContext'
import { GetUser } from '../../../firebase/firebase'
import { ProfileCard } from './profile.constants'
export default function Profile({ match }) {
    const { currentUser } = useAuth()
    const [user, setUser] = useState('')
    const [loading, setLoading] = useState(true)
    const [isEditMode, setIsEditMode] = useState(false)

    useEffect(() => {
        if (loading) {
            GetUser(currentUser.uid).then((user) => {
                setUser(user.data())
                setLoading(false)


            })
        }
    }, [isEditMode, loading])

    const toggleEdit = (e) => {
        setIsEditMode(!isEditMode)
    }

    const toggleLoading = (e) => {
        setLoading(!loading)
    }

    return (
        <>

            {!loading && user ? <ProfileCard user={user} toggleEdit={toggleEdit} isEditMode={isEditMode} toggleLoading={toggleLoading} /> :
                ''}



        </>
    )
}
